import  { useEffect, useState } from "react";
import axios from "axios";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
);

const IncidentSeverity = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/healthAndSafetyJson`
        );
        

        const rawData = response.data.data.Data;
        
        const filteredData = rawData.filter(item => typeof item["__EMPTY"] === "number");

        // Process data to count severity levels for each location
        const severityCountsByLocation = filteredData.reduce((acc, item) => {
          const location = item["__EMPTY_2"];
          const severity = item["__EMPTY_5"];
          if (!acc[location]) acc[location] = {};
          acc[location][severity] = (acc[location][severity] || 0) + 1;
          return acc;
        }, {});

        const locations = Object.keys(severityCountsByLocation);
        const severityLevels = [...new Set(filteredData.map(item => item["__EMPTY_5"]))];

        const datasets = severityLevels.map(severity => ({
          label: severity,
          data: locations.map(location => severityCountsByLocation[location][severity] || 0),
          backgroundColor: getRandomColor(),
        }));

        setChartData({
          labels: locations,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          stacked: true,
          title: {
            display: true,
            text: 'Location',
          },
        },
        y: {
          stacked: true,
          beginAtZero: true,
          title: {
            display: true,
            text: 'Number of Incidents',
          },
        },
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Distribution of Severity Levels for Incidents
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Bar
              data={chartData}
              options={options}
            />
          </div>
        </Container>
      </div>
    );
  }
};

export default IncidentSeverity;
